import { render } from "./PanelRelatedItem.vue?vue&type=template&id=f5c0f77c&scoped=true&ts=true"
import script from "./PanelRelatedItem.vue?vue&type=script&lang=ts"
export * from "./PanelRelatedItem.vue?vue&type=script&lang=ts"

import "./PanelRelatedItem.vue?vue&type=style&index=0&id=f5c0f77c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5c0f77c"]])

export default __exports__